// src/utils/productChangeHelpers.ts

import type { ChangeSummary } from "../types";

interface Spec {
    id: string;  // unique identifier
    key: string;
    value: string;
}

export const applySpecChanges = (currentSpecs: Spec[], specChanges: any) => {
    if (!specChanges?.changes) return currentSpecs;

    // Start with current specs
    const updatedSpecs = [...currentSpecs];

    specChanges.changes.forEach((change: any) => {
        const index = updatedSpecs.findIndex(s => s.key === change.key);

        if (change.action === 'removed') {
            // ✅ Remove the spec
            if (index !== -1) {
                updatedSpecs.splice(index, 1);
            }
        } else if (change.action === 'added' || change.action === 'changed') {
            // ✅ Add or update the spec
            if (index !== -1) {
                updatedSpecs[index] = { key: change.key, value: change.new_value };
            } else {
                updatedSpecs.push({ key: change.key, value: change.new_value });
            }
        }
    });

    return updatedSpecs;
};

export const applyTagChanges = (currentTags: string[], tagChanges: any) => {
    if (!tagChanges?.items) return currentTags;

    // Start with current tags
    let updatedTags = [...currentTags];

    tagChanges.items.forEach((item: any) => {
        if (item.action === 'added') {
            // ✅ Add tag if not already present
            if (!updatedTags.includes(item.value)) {
                updatedTags.push(item.value);
            }
        } else if (item.action === 'removed') {
            // ✅ Remove tag
            updatedTags = updatedTags.filter(t => t !== item.value);
        }
        // 'unchanged' → do nothing
    });

    return updatedTags;
};

export const getFieldValue = (
    fieldName: string,
    defaultValue: any,
    changeSummary: ChangeSummary | null,
    applyPendingChanges: boolean
): any => {
    // ✅ If we shouldn't apply changes or no change summary, return default
    if (!applyPendingChanges || !changeSummary) {
        return defaultValue;
    }

    // ✅ Check if the field has changes in the summary
    if (changeSummary[fieldName]?.new !== undefined) {
        return changeSummary[fieldName].new;
    }

    return defaultValue;
};
